const openTagRegExp = /<[^strong|/|img|a|blockquote]\s*[\w|=|'|"|-]*>/i
const closeTagRegExp = /<\/[^strong|img|a|blockquote]\s*>/gi

interface IEditorData {
  blocks: any[]
  time: number
  version: string
}

const divideContent = (text: string, divider: number) => {
  return [text.slice(0, divider), text.slice(divider)]
}

const defineMiddle = (
  half: number,
  length: number,
  closeTagIdx: number | null,
  openTagIdx: number | null
) => {
  if (!(closeTagIdx && openTagIdx)) return length
  return half - closeTagIdx > openTagIdx - half ? openTagIdx : closeTagIdx
}

const checkAccordion = (text: string) => {
  const half = Math.floor(text.length / 2)
  const indexStartAccardion = text.indexOf('accordion')
  if (indexStartAccardion !== -1 && indexStartAccardion < half) {
    const endAccordion = text.indexOf('</div>', indexStartAccardion) + 6
    return endAccordion
  }
  return 0
}

const textPartsQuill = (text: string) => {
  const length = text.length
  let half = Math.floor(length / 2)

  const accordionIndex = checkAccordion(text)
  if (accordionIndex) half = accordionIndex

  const [firstHalf, secondHalf] = divideContent(text, half)

  const matchOpenTags = secondHalf.match(openTagRegExp)

  const openTagIdx =
    matchOpenTags && matchOpenTags.length ? secondHalf.indexOf(matchOpenTags[0]) + half : null

  const matchCloseTags = firstHalf.match(closeTagRegExp)

  const closeTagIdx =
    matchCloseTags && matchCloseTags.length
      ? firstHalf.lastIndexOf(matchCloseTags[matchCloseTags.length - 1]) +
        matchCloseTags[matchCloseTags.length - 1].length
      : null

  const halfArticleIndex = defineMiddle(half, length, closeTagIdx, openTagIdx)
  return divideContent(text, halfArticleIndex)
}

/** Разделяет данные редактора на 2 части по заданному процентному соотношению
 * @param parsedData - данные редактора
 * @param percentRatio - процентное соотношение для деления статьи
 */
const splitEditorData = (parsedData: IEditorData, percentRatio = 50) => {
  const blockLastIndex = parsedData.blocks.length - 1
  const blocksMiddleIndex = Math.ceil(parsedData.blocks.length / (100 / percentRatio))
  const normalizedMiddleIndex =
    blocksMiddleIndex > blockLastIndex ? blockLastIndex : blocksMiddleIndex

  const initEditorData = {
    time: parsedData.time,
    version: parsedData.version,
  }

  const splittedData = parsedData.blocks.reduce(
    (acc, block, index) => {
      const indexToPush = index < normalizedMiddleIndex ? 0 : 1
      acc[indexToPush].blocks.push(block)
      return acc
    },
    [
      { ...initEditorData, blocks: [] },
      { ...initEditorData, blocks: [] },
    ]
  )
  return splittedData
}

export { textPartsQuill, splitEditorData }
export type { IEditorData }
